import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersShiftProtection(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={59} height={59} fill="none" {...props}>
      <path
        fill="#169563"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <g clipPath="url(#TiersShiftProtection_svg__a)">
        <path
          fill="url(#TiersShiftProtection_svg__b)"
          d="M58.065 11.32c-13.674 0-19.788-6.938-19.847-7.006-.355-.419-1.08-.419-1.436 0-.06.07-6.11 7.005-19.847 7.005a.926.926 0 0 0-.935.917v17.5c0 9.567 4.384 18.658 11.728 24.319 2.96 2.282 6.158 3.933 9.506 4.907a.95.95 0 0 0 .532 0c3.348-.974 6.546-2.625 9.506-4.907C54.616 48.393 59 39.303 59 29.736v-17.5a.926.926 0 0 0-.935-.917Zm-4.721 18.416c0 7.878-3.577 15.338-9.567 19.956-1.99 1.535-4.096 2.712-6.277 3.51-2.18-.797-4.286-1.975-6.277-3.51-5.99-4.617-9.566-12.077-9.566-19.956V16.613c4.782-.523 9.229-1.848 13.052-3.907a29 29 0 0 0 2.8-1.714 29 29 0 0 0 2.811 1.716c3.827 2.055 8.264 3.378 13.025 3.903z"
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m31.996 31.437 4.128 4.112 9.632-10.966"
        />
      </g>
      <defs>
        <linearGradient
          id="TiersShiftProtection_svg__b"
          x1={37.5}
          x2={37.5}
          y1={4}
          y2={59.001}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="TiersShiftProtection_svg__a">
          <path fill="#fff" d="M16 4h43v55H16z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersShiftProtection);
export default ForwardRef;
